/* eslint-disable */

import moment from 'moment';
import { makeAutoObservable } from 'mobx';
import {
    getDefaultModelSchema,
    update,
    serialize,
    serializable,
    alias,
    identifier,
    list,
    object,
    primitive,
} from 'serializr';

import Court from './Court';

class Ratings {
    @serializable ntrp!: number;
    @serializable ello!: number;
    @serializable other!: number;

    constructor() {
        makeAutoObservable(this);
    }

    fromJSON(json: any) {
        update<Ratings>(this, json);
        return this;
    }

    toJSON() {
        return serialize<Ratings>(this);
    }
}

class Calendar {
    @serializable date!: string;
    @serializable(list(primitive())) time!: string[];

    constructor() {
        makeAutoObservable(this);
    }

    fromJSON(json: any) {
        update<Calendar>(this, json);
        return this;
    }

    toJSON() {
        return serialize<Calendar>(this);
    }
}

class Preference {
    @serializable(list(primitive())) court!: string[];
    @serializable(list(primitive())) play!: string[];
    @serializable(list(primitive())) training!: string[];

    constructor() {
        makeAutoObservable(this);
    }

    fromJSON(json: any) {
        update<Preference>(this, json);
        return this;
    }

    toJSON() {
        return serialize<Preference>(this);
    }
}

export default class User {
    @serializable(alias('_id', identifier())) id!: string;

    @serializable image!: string;
    @serializable gender!: string;
    @serializable firstName!: string;
    @serializable lastName!: string;
    @serializable email!: string;
    @serializable password!: string;
    @serializable(list(primitive())) languages!: string[];
    @serializable location!: string;
    @serializable address!: string;
    @serializable phone!: string;

    @serializable age!: number;
    @serializable experience!: number;

    @serializable(object(Preference)) preference!: Preference;

    @serializable(object(Ratings)) ratings!: Ratings;

    @serializable(list(object(Calendar))) calendar!: Calendar[];

    friends!: User[]; // TODO: @serializable(list(object(User))
    @serializable(list(object(Court))) courts!: Court[];

    @serializable totalGames!: string;
    @serializable rating!: string;

    @serializable available!: string;

    @serializable status!: string;
    @serializable role!: string;

    @serializable verified!: boolean;

    @serializable visitedAt!: string;

    get name() {
        return ((this.firstName || '') + ' ' + (this.lastName || '')).trim() || 'Undefined';
    }

    get lastSeen() {
        if (!this.visitedAt) {
            return 'Recently';
        }

        const today = moment();
        const visitedAt = moment(this.visitedAt);

        const month = today.diff(visitedAt, 'days');
        if (month >= 20) {
            return 'Recently';
        }

        return visitedAt.fromNow();
    }

    constructor() {
        const schema = getDefaultModelSchema<this>(User);
        if (schema) {
            schema.props.friends = list(object(User));
        }

        makeAutoObservable(this);
    }

    clone() {
        return new User().fromJSON(this.toJSON());
    }

    fromJSON(json: any) {
        update<User>(this, json);
        return this;
    }

    toJSON() {
        return serialize<User>(this);
    }
}
